<template>
  <div class="modal" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <form @submit.prevent="saveFunction">
        <div class="modal-header">
          <h1>Edit function</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                  aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="code" class="form-label">Code</label>
            <input type="text" class="form-control" id="code" v-model="functionData.code" ref="inputCode" required>
          </div>
          <div class="mb-3">
            <label for="description" class="form-label">Description</label>
            <input type="text" class="form-control" id="description" v-model="functionData.description" required>
          </div>
          <div class="mb-3">
            <label for="sub_location_id" class="form-label">Sublocation</label>
            <select class="form-select" id="sub_location_id" v-model="functionData.sub_location_id" required>
              <option v-for="subLocation in subLocations" :key="subLocation.id" :value="subLocation.id">
                {{ subLocation.name }}
              </option>
            </select>
          </div>
          <div class="form-check ">
            <label for="published" class="form-check-label">Published</label>
            <input type="checkbox" class="form-check-input" value="" id="published" v-model="functionData.published"
                   placeholder="Published" checked/>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel
          </button>
          <button type="submit" class="btn btn-primary">Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditFunctionModal',
  props: {
    function: {
      type: Object,
      required: true,
    },
    subLocations: {
      type: Array,
      required: true,
    }
  },
  mounted() {
    this.$refs.inputCode.focus();
  },
  data() {
    return {
      functionData: {...this.function, sub_location_id: this.function.sub_location.id},
    };
  },
  methods: {
    async saveFunction() {
      this.$emit('save-function', this.functionData);
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>